import React, { useState } from "react";
import { Download, ShoppingCart, CheckCircle2, X } from "lucide-react";
import { Button } from "../ui/button";
import BookPayButton from "./BookPayButton";
import { money, bookDownloadUrl } from "../../lib/api";

export const BookCard = ({ book }) => {
  const [buying, setBuying] = useState(false);
  const [downloadToken, setDownloadToken] = useState(null);

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden flex flex-col" data-testid={`book-card-${book.id}`}>
      <div className="bg-cream flex items-center justify-center p-6">
        <img
          src={book.cover_url}
          alt={book.title}
          className="h-64 w-auto rounded-lg shadow-lg object-contain"
          data-testid="book-cover"
        />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-serif text-xl font-bold text-navy leading-snug">{book.title}</h3>
        <p className="text-sm text-gold-dark font-medium mt-1">by {book.author}</p>
        <p className="text-sm text-gray-600 mt-3 leading-relaxed flex-1">{book.description}</p>
        <div className="flex items-center gap-3 mt-3 text-xs text-gray-400">
          {book.pages && <span>{book.pages} pages</span>}
          {book.isbn && <span>ISBN {book.isbn}</span>}
          <span className="text-navy font-medium">PDF · Digital Download</span>
        </div>

        <div className="mt-5">
          {downloadToken ? (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 space-y-3" data-testid="book-purchase-success">
              <div className="flex items-center gap-2 text-green-700 text-sm font-medium">
                <CheckCircle2 className="h-5 w-5" /> Purchase complete — thank you!
              </div>
              <a href={bookDownloadUrl(downloadToken)} target="_blank" rel="noreferrer" data-testid="book-download-link">
                <Button className="w-full bg-navy hover:bg-navy-light text-white font-semibold">
                  <Download className="h-4 w-4 mr-1.5" /> Download Your Book (PDF)
                </Button>
              </a>
              <p className="text-[11px] text-gray-500">Save this page or bookmark the link — you can re-download anytime.</p>
            </div>
          ) : buying ? (
            <div className="space-y-2">
              <BookPayButton bookId={book.id} onPurchased={setDownloadToken} />
              <button
                onClick={() => setBuying(false)}
                className="w-full text-center text-xs text-gray-400 hover:text-navy flex items-center justify-center gap-1"
                data-testid="book-cancel-buy"
              >
                <X className="h-3 w-3" /> Cancel
              </button>
            </div>
          ) : (
            <div className="flex items-center justify-between gap-3">
              <div className="font-serif text-2xl font-bold text-navy" data-testid="book-price">{money(book.price)}</div>
              <Button
                onClick={() => setBuying(true)}
                className="bg-gold hover:bg-gold-dark text-navy font-semibold h-11 px-6"
                data-testid="book-buy-button"
              >
                <ShoppingCart className="h-4 w-4 mr-1.5" /> Buy Digital Download
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookCard;
